import { render, staticRenderFns } from "./CarEditor.vue?vue&type=template&id=a60e769e&lang=pug&"
import script from "./CarEditor.vue?vue&type=script&lang=js&"
export * from "./CarEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports